import { ModalContext } from '@/contexts/modal/helpers';
import { useContext } from 'react';

const useModal = () => useContext(ModalContext);

export default useModal;
